module.exports = __webpack_public_path__ + "static/img/default-black.56355fc8.jpg";